import angular from 'angular';
import AutoCapitalizeDirective from './capitalize.directive';

let AutoCapitalizeModule = angular.module('auto-capitalize-module', [])

    .directive('capitalize', AutoCapitalizeDirective)

    .name;

export default AutoCapitalizeModule;


// WEBPACK FOOTER //
// ./client/app/common/auto-capitalize/index.js